import styled, { css } from 'styled-components'

type ResultsContainerProps = {
  color: string
  elementVisible: boolean
}
export const ResultsContainer = styled.div<ResultsContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1170px;
  align-items: center;
  justify-content: center;
  gap: 112px;

  .container {
    display: flex;
    flex-direction: column;
    gap: 40px;
    width: 100%;

    .title {
      width: 100%;
      position: relative;
      z-index: 1;
      .bar {
        border: 2px solid ${(props) => props.color};
        position: absolute;
        width: 0;
        max-width: 543px;
        left: 0;
        bottom: 0.6rem;
        z-index: -1;
        transition: width 0.8s ease-in;

        ${({ elementVisible }) =>
          elementVisible &&
          css`
            width: 100%;
          `}
      }
    }
    .descriptions {
      display: flex;
      gap: 80px;
      align-items: flex-start;
      width: 100%;

      .description {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        width: 100%;
        max-width: 545px;
      }
    }
  }

  .banner {
    width: 100%;
    height: auto;
  }

  .banner-mobile {
    display: none;
  }

  @media (max-width: 791px) {
    gap: 40px;
    .container {
      gap: 12px;
      .title .bar {
        bottom: -0.1rem;
      }
      .descriptions {
        flex-direction: column;
        gap: 16px;
      }
    }
  }

  @media (max-width: 500px) {
    .banner {
      display: none;
    }
    .banner-mobile {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
`
